<template>
  <v-card class="ma-0" width="100%" style="height: auto" elevation="2">
    <v-container class="pa-0 d-flex flex-column" style="height: 100%">
      <v-app-bar flat class="mt-0 mb-2 pt-1 px-4" dense height="30">
        <v-toolbar-title>{{ $t("accountingDocument") }}</v-toolbar-title>
        <v-spacer />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!isMobile && !id"
              v-bind="attrs"
              icon
              small
              class="float-left"
              v-on="on"
              @click="create"
            >
              <v-icon color="green" style="font-size: 22px">
                mdi-content-save-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("submit") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!isMobile && id"
              v-bind="attrs"
              icon
              small
              class="float-left"
              v-on="on"
              @click="update"
            >
              <v-icon color="green" style="font-size: 22px">
                mdi-content-save-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("submit") }}</span>
        </v-tooltip>
        <v-tooltip v-if="selected.length > 0" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              icon
              small
              class="float-left"
              v-on="on"
              @click="deletDialog = true"
            >
              <v-icon color="pink" style="font-size: 22px">
                mdi-trash-can-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("remove") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              icon
              small
              class="float-left"
              v-on="on"
              @click="showSelect = !showSelect"
            >
              <v-icon color="blue" style="font-size: 22px">
                {{
                  showSelect
                    ? "mdi-checkbox-blank-outline"
                    : "mdi-checkbox-marked-outline"
                }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("select-row") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!formType"
              v-bind="attrs"
              icon
              small
              v-on="on"
              @click="goTo('accountingList')"
            >
              <v-icon color="primary" style="font-size: 22px">
                mdi-format-list-numbered
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("accountingList") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!formType"
              v-bind="attrs"
              icon
              small
              v-on="on"
              @click="$router.go(-1)"
            >
              <v-icon color="primary" style="font-size: 22px"> mdi-arrow-left </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("back") }}</span>
        </v-tooltip>
      </v-app-bar>
      <v-form v-if="render" id="app" ref="form" v-model="valid" lazy-validation>
        <v-tabs>
          <v-tab>
            {{ $t("public-information") }}
          </v-tab>
          <v-tab :disabled="!documentPermmission">
            {{ $t("documents") }}
          </v-tab>
          <v-tab-item>
            <v-row class="mx-0 my-2">
              <v-col cols="12" md="6" sm="6" class="mb-0">
                <v-text-field
                  v-model="content"
                  height="20"
                  :label="$t('documentContent')"
                  dense
                  autofocus
                  outlined
                  clearable
                />
              </v-col>
              <v-col cols="12" md="2" sm="2" class="mb-0">
                <v-select
                  v-model="type"
                  :label="$t('documentType')"
                  :items="typeItems"
                  height="30"
                  dense
                  outlined
                  item-value="value"
                  item-text="text"
                />
              </v-col>
              <v-col cols="12" md="2" sm="2">
                <template>
                  <v-text-field
                    id="from"
                    v-model="date"
                    :label="$t('date')"
                    :rules="[(v) => !!v || $t('is-required')]"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    clearable
                  />
                  <date-picker
                    v-model="date"
                    element="from"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :min="$store.state.startDate"
                    :max="$store.state.endDate"
                    :color="
                      this.$vuetify.theme.themes[
                        this.$vuetify.theme.isDark ? 'dark' : 'light'
                      ].primary
                    "
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col cols="12" md="2">
                <tag v-model="tag" :solo="false" :input="tag" :height="25" />
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-text-field
                  v-model="number"
                  height="20"
                  dense
                  :rules="[(v) => !!v || $t('is-required')]"
                  outlined
                  clearable
                  :label="$t('number')"
                  @blur="getDocumentNumber"
                />
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-text-field
                  v-model="turningNumber"
                  height="20"
                  dense
                  :rules="[(v) => !!v || $t('is-required')]"
                  outlined
                  clearable
                  :label="$t('turningNumber')"
                  disabled
                />
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-text-field
                  v-model="dailyNumber"
                  height="20"
                  dense
                  :rules="[(v) => !!v || $t('is-required')]"
                  outlined
                  clearable
                  :label="$t('dailyNumber')"
                  disabled
                />
              </v-col>
              <v-col class="mb-0 pb-0" cols="12" md="3" sm="3" style="height: 55px">
                <status
                  v-model="status"
                  :hideconfig="true"
                  :type="type"
                  :value="status"
                />
              </v-col>
              <v-col cols="12" md="3">
                <autocomplete
                  v-model="branch"
                  :title="$t('branch')"
                  type="branch"
                  :set-init="true"
                  :value="branch"
                />
              </v-col>
            </v-row>
            <v-col cols="12" class="px-2 py-0 border-datatable" style="zoom: 0.85">
              <div class="ag-theme-alpine custom-grid-theme">
                <AgGridVue
                  class="ag-theme-alpine mt-4 px-1 accounting"
                  style="width: 100%; height: calc(-500px + 100vh)"
                  :columnDefs="columnDefs"
                  :rowData="rowData"
                  :defaultColDef="defaultColDef"
                  :gridOptions="gridOptions"
                  :getRowId="getRowId"
                  rowSelection="multiple"
                  suppressRowClickSelection="false"
                  :singleClickEdit="false"
                  :suppressHorizontalScroll="false"
                  :domLayout="'normal'"
                  :stopEditingWhenCellsLoseFocus="true"
                  :context="{
                    componentParent: this,
                    currency: this.$store.state.currency.symbol,
                  }"
                  @grid-ready="onGridReady"
                  @column-resized="onColumnResized"
                  @selection-changed="onSelectionChanged"
                  @row-drag-end="onRowDragEnd"
                  :overlayLoadingTemplate="`<span class='ag-overlay-loading-center'>${$t(
                    'fetching-data'
                  )}</span>`"
                  :overlayNoRowsTemplate="`<span class='ag-overlay-loading-center'>${$t(
                    'no-data-found'
                  )}</span>`"
                />
              </div>
              <!--footer-->
              <v-row>
                <v-col cols="12" class="mb-0">
                  <v-simple-table class="summary-footer px-1" dense>
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td
                            style="width: 66%; border-top: 1px solid #e3e3e3 !important"
                          >
                            <div class="d-flex justify-start">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-shortkey="['f2']"
                                    v-bind="attrs"
                                    icon
                                    small
                                    class="float-left"
                                    @shortkey="addRow()"
                                    v-on="on"
                                    @click="addRow()"
                                  >
                                    <v-icon color="teal" style="font-size: 22px">
                                      mdi-plus-box-outline
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t("newRow") }} (f2)</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    icon
                                    small
                                    class="float-left"
                                    :disabled="selected.length > 0 ? false : true"
                                    v-on="on"
                                    @click="openDeleteDialogVerify()"
                                  >
                                    <v-icon color="pink" style="font-size: 22px">
                                      mdi-trash-can-outline
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t("remove") }} (f2)</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    icon
                                    small
                                    class="float-left"
                                    :disabled="selected.length > 0 ? false : true"
                                    v-on="on"
                                    @click="copyRow"
                                  >
                                    <v-icon color="blue" style="font-size: 22px">
                                      mdi-content-copy
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t("copy") }}</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    icon
                                    small
                                    class="float-left"
                                    :disabled="selected.length > 0 ? false : true"
                                    v-on="on"
                                    @click="reverseRow"
                                  >
                                    <v-icon color="blue" style="font-size: 22px">
                                      mdi-repeat-variant
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t("reverseRow") }}</span>
                              </v-tooltip>
                            </div>
                          </td>
                          <td style="border-top: 1px solid #e3e3e3 !important" />
                          <td
                            style="
                              border-top: 1px solid #e3e3e3 !important;
                              background: aliceblue;
                            "
                          >
                            {{ $t("debtor") }}
                          </td>
                          <td
                            style="
                              border-top: 1px solid #e3e3e3 !important;
                              background: antiquewhite;
                            "
                          >
                            {{ $t("creditor") }}
                          </td>
                        </tr>
                        <tr>
                          <td rowspan="2" style="padding: 0 !important">
                            <div>
                              <table class="visual">
                                <tr>
                                  <td class="column-width-small">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1">{{ $t("row") }} : </span>
                                      <span class="text-body-2">{{
                                        selectedRowIndex ? selectedRowIndex : ""
                                      }}</span>
                                    </v-card-text>
                                  </td>
                                  <td class="column-width">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1"
                                        >{{ $t("given") }} :
                                      </span>
                                      <span class="text-body-2">{{
                                        selectedRowData?.given?.name || ""
                                      }}</span>
                                    </v-card-text>
                                  </td>
                                  <td class="column-width">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1">{{ $t("fin4") }} : </span>
                                      <span class="text-body-2">{{
                                        selectedRowData?.fin4?.name || ""
                                      }}</span>
                                    </v-card-text>
                                  </td>
                                  <td class="column-width">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1">{{ $t("fin5") }} : </span>
                                      <span class="text-body-2">{{
                                        selectedRowData?.fin5?.name || ""
                                      }}</span>
                                    </v-card-text>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="column-width">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1">{{ $t("fin6") }} : </span>
                                      <span class="text-body-2">{{
                                        selectedRowData?.fin6?.name || ""
                                      }}</span>
                                    </v-card-text>
                                  </td>
                                  <td class="column-width-small">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1"
                                        >{{ $t("debtor") }} :
                                      </span>
                                      <span class="text-body-2">
                                        {{
                                          selectedRowData && selectedRowData.debtor
                                            ? $numberFormat(selectedRowData.debtor, 10)
                                            : "0"
                                        }}
                                        {{ $store.state.currency.symbol }}
                                      </span>
                                    </v-card-text>
                                  </td>
                                  <td class="column-width">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1"
                                        >{{ $t("creditor") }} :
                                      </span>
                                      <span class="text-body-2">
                                        {{
                                          selectedRowData && selectedRowData.creditor
                                            ? $numberFormat(selectedRowData.creditor, 10)
                                            : "0"
                                        }}
                                        {{ $store.state.currency.symbol }}
                                      </span>
                                    </v-card-text>
                                  </td>
                                  <td class="column-width">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1"
                                        >{{ $t("description") }} :
                                      </span>
                                      <span class="text-body-2">{{
                                        selectedRowData?.content || ""
                                      }}</span>
                                    </v-card-text>
                                  </td>
                                </tr>
                                <tr>
                                  <td class="column-width-small">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1"
                                        >{{ $t("count") }} :
                                      </span>
                                      <span class="text-body-2">{{
                                        selectedRowData?.count || ""
                                      }}</span>
                                    </v-card-text>
                                  </td>
                                  <td class="column-width">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1"
                                        >{{ $t("issueTracking") }} :
                                      </span>
                                      <span class="text-body-2">{{
                                        selectedRowData?.tracking_number || ""
                                      }}</span>
                                    </v-card-text>
                                  </td>
                                  <td class="column-width-small">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1"
                                        >{{ $t("currency") }} :
                                      </span>
                                      <span class="text-body-2">{{
                                        selectedRowData?.currency?.name || ""
                                      }}</span>
                                    </v-card-text>
                                  </td>
                                  <td class="column-width">
                                    <v-card-text
                                      class="pa-0"
                                      style="
                                        flex: 0 0 auto;
                                        width: auto;
                                        height: 38px;
                                        overflow: hidden;
                                      "
                                    >
                                      <span class="text-body-1"
                                        >{{ $t("currency-rate") }} :
                                      </span>
                                      <span class="text-body-2">
                                        {{
                                          selectedRowData &&
                                          selectedRowData.currency_amount
                                            ? $numberFormat(
                                                selectedRowData.currency_amount,
                                                10
                                              )
                                            : "0"
                                        }}
                                        {{ $store.state.currency.symbol }}
                                      </span>
                                    </v-card-text>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </td>
                          <td>{{ $t("sum") }}</td>
                          <td>{{ $numberFormat(totals.debtor, 10) }}</td>
                          <td>{{ $numberFormat(totals.creditor, 10) }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t("remain") }}</td>
                          <td>
                            {{
                              $numberFormat(
                                +totals.debtor - +totals.creditor > 0
                                  ? +totals.debtor - +totals.creditor
                                  : 0,
                                10
                              )
                            }}
                          </td>
                          <td>
                            {{
                              $numberFormat(
                                +totals.creditor - +totals.debtor > 0
                                  ? +totals.creditor - +totals.debtor
                                  : 0,
                                10
                              )
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>
          </v-tab-item>
          <v-tab-item>
            <v-row class="mx-0 pt-2">
              <v-col cols="12" md="3" sm="3">
                <file-picker
                  ref="refFilePicker"
                  v-model="attachments"
                  :label="$t('addDocuments')"
                  :multiple="true"
                  type-prop="accounting"
                  :val="id && attachments ? attachments : null"
                />
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs>
      </v-form>
      <v-container
        class="d-flex align-end"
        style="padding-right: 10px !important; flex: 1 1 auto"
      >
        <v-btn
          v-if="!id"
          color="primary"
          class="ps-1"
          :loading="isLoading"
          @click="create"
        >
          {{ $t("submit") }}
        </v-btn>
        <v-btn
          v-if="id"
          color="primary"
          class="ps-1"
          :loading="isLoading"
          @click="update"
        >
          {{ $t("edit") }}
        </v-btn>
      </v-container>
    </v-container>

    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="alertDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="alertDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ alertText }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn color="primary" @click="draftStore">
                {{ $t("submit") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="alertDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--dialog given ag-autocomplete-->
    <v-dialog
      v-model="givenDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
      attach="#app"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="givenDialog = false">
            <v-icon class="close-hover" color="grey" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("accountStracture") }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div class="overflow-y-auto ma-2 mt-0" style="height: 350px">
            <accountingCoding
              v-model="newGiven"
              :return-object="true"
              @close="givenDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--dialog detail-->
    <v-dialog
      v-model="detailDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="detailDialog = false">
            <v-icon class="close-hover" color="grey" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("accountStracture") }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div class="overflow-y-auto ma-2 mt-0" style="height: 350px">
            <detail
              v-model="newDetail"
              :return-object="true"
              @input="newDetail"
              @close="detailDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--dialog account-->
    <v-dialog
      v-model="accountDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="accountDialog = false">
            <v-icon class="close-hover" color="grey" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("new-account") }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div class="overflow-y-auto ma-2 mt-0" style="height: auto">
            <customer
              v-model="newAccount"
              :return-object="true"
              @close="accountDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--product dialog-->
    <v-dialog
      v-model="productDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="productDialog = false">
            <v-icon class="close-hover" large color="grey"> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div class="overflow-y-auto ma-2 mt-0" style="height: 350px">
            <product
              v-model="newProduct"
              form-type="product"
              @close="productDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'blue'"
      top
      :timeout="snakbarTimeOut"
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <!--<date-picker
      :show="showAGDatePicker" 
      @close="closeAGDatePicker" 
      v-model="AGSelectedDate"
    />-->
  </v-card>
</template>

<script>
import Vue from "vue";
import Task from "../task/task";
import General from "../../../../Mixins/general";
import autocomplete from "../../components/general/patial/autocomplete";
import Sortable from "sortablejs";
import filePicker from "../../components/general/filePicker/index";
import moment from "moment-jalaali";
import accountingCoding from "@/views/dashboard/pages/accounting/coding.vue";
import Detail from "@/views/dashboard/pages/account/detail.vue";
import customer from "@/views/dashboard/pages/account/customer.vue";
import Product from "@/views/dashboard/pages/product/product.vue";

import { AgGridVue } from "ag-grid-vue";
import AgAutoComplete from "@/views/dashboard/components/general/AgGridComponents/Ag-autocomplete.vue";
import AgMoney from "@/views/dashboard/components/general/AgGridComponents/Ag-money.vue";
import AgVMenu from "@/views/dashboard/components/general/AgGridComponents/Ag-vmenu.vue";

function initialData() {
  return {
    selected: [],
    currencyOptions: {
      locale: "en-US",
      prefix: "",
      suffix: " ",
      precision: 10,
    },
    printDialog: false,
    attachments: null,
    deletDialog: false,
    alertDialog: false,
    alertText: null,
    showSelect: true,
    filter: false,
    render: true,
    valid: true,
    number: null,
    date: null,
    content: null,
    model: null,
    from: 1,
    taskDialog: null,
    id: null,
    documentRouteId: null,
    loadedDocumentId: null,
    status: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    turningNumber: null,
    dailyNumber: null,
    items: [],
    typeItems: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 1000,
    isLoading: false,
    snakbar: false,
    type: "general",
    taskId: null,
    snakbarText: null,
    snakbarTimeOut: null,
    loading: true,
    tableOptions: {
      itemsPerPage: 1000,
    },
    headers: null,
    draftStatus: false,
    search: null,
    showAGDatePicker: false,
    AGSelectedDate: null,
    currentEditor: null,
    newNum: null,
    docCreated: false,

    givenDialog: false,
    newGiven: null,
    detailDialog: false,
    newDetail: null,
    accountDialog: false,
    newAccount: null,
    productDialog: false,
    newProduct: null,
    totals: { debtor: 0, creditor: 0 },

    defaultColDef: {
      /* flex: 1, */
      resizable: true,
    },
    gridOptions: {
      enableRtl: true,
      context: { componentParent: this },
      rowSelection: "multiple",
      rowDragManaged: true,
      suppressRowClickSelection: false,
      suppressKeyboardEvent: (params) => {
        const e = params.event;
        const key = e.key;
        // Detect if AgAutoComplete editor is open
        const isEditingAutoComplete =
          params.node?.editing &&
          params.api?.getEditingCells?.()?.some(
            (cell) =>
              cell.rowIndex === params.node.rowIndex && cell.column.getColId() === "given" // your autocomplete column field
          );
        // If editing the autocomplete cell, block grid navigation keys
        if (isEditingAutoComplete) {
          if (["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(key)) {
            return true; // stop grid from handling these keys
          }
        }
        return false;
      },
      suppressHorizontalScroll: true,
      rowHoverHighlight: false,
    },
    gridApi: null,
    columnDefs: null,
    rowData: null,
    invalidCellsMap: {},
    selectedRowData: null,
    selectedRowIndex: null,
  };
}
export default {
  name: "Document",
  components: {
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    filePicker,
    autocomplete,
    Task,
    accountingCoding,
    Detail,
    customer,
    Product,

    AgGridVue: Vue.extend(AgGridVue),
    AgVMenu: Vue.extend(AgVMenu),
    AgAutoComplete: Vue.extend(AgAutoComplete),
    AgMoney: Vue.extend(AgMoney),
  },
  directives: {
    sortableDataTable: {
      bind(el, binding, vnode) {
        const options = {
          animation: 0,
        };
        Sortable.create(el.getElementsByTagName("tbody")[0], options);
      },
    },
  },
  activated: function () {
    if (
      this.documentRouteId != null &&
      String(this.$route.params.id) !== String(this.documentRouteId)
    ) {
      return;
    }
    this.syncRouteDocument();
  },
  created() {
    this.documentRouteId = this.$route.params.id != null ? this.$route.params.id : null;
  },
  mixins: [General],
  props: ["input", "formType", "refId", "itemsProp"],
  data: function () {
    return initialData();
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
  },
  watch: {
    itemsProp: {
      handler(val) {
        if (val) {
          this.getNewNum();
        }
      },
      deep: true,
    },
    newProduct() {
      if (this.newProduct) {
        this.productDialog = false;
        if (this.params.type === "detail") {
          this.newProduct.id = this.newProduct.fin_id;
        }
        this.setModel(this.newProduct);
      }
    },
    newAccount() {
      if (this.newAccount) {
        this.accountDialog = false;
        if (this.params.type === "detail") {
          this.newAccount.id = this.newAccount.fin_id;
        }
        this.setModel(this.newAccount);
      }
    },
    newGiven() {
      if (this.newGiven) {
        this.givenDialog = false;
        this.setModel(this.newGiven);
      }
    },
    setModel(item) {
      // this.items = [item]
      var app = this;
      if (this.multiple) {
        app.items = [...app.items, ...Array.from(item)];
        this.search = null;
      } else {
        this.items.push(item);
      }
      this.model = item;
      this.id = item;
    },
    newDetail() {
      if (this.newDetail) {
        this.detailDialog = false;
        this.setModel(this.newDetail);
      }
    },
    AGSelectedDate(val) {
      /*  console.log('test 2 : ' + val) */
    },
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    search() {
      var app = this;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    tableOptions: {
      handler() {
        var app = this;
        app.sortBy = [];
        if (app.tableOptions.sortBy) {
          app.tableOptions.sortBy.map(function (value, key) {
            const index = app.headers.findIndex((h) => h.value === value);
            app.sortBy.push(app.headers[index].table);
          });
        }
      },
      deep: true,
    },
    items: {
      handler() {
        this.items.map(function (item, index) {
          item.i = index;
        });
      },
      deep: true,
    },
    rowData: {
      handler(newVal) {
        if (!newVal || !newVal.length) {
          this.totals = { debtor: 0, creditor: 0 };
          return;
        }
        const totals = newVal.reduce(
          (acc, row) => {
            acc.debtor += parseFloat(row.debtor || 0);
            acc.creditor += parseFloat(row.creditor || 0);
            return acc;
          },
          { debtor: 0, creditor: 0 }
        );
        this.totals = totals;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.initialMounted();
    document.addEventListener("keydown", this.globalKeyDown);
    if (!this.id && !this.itemsProp) {
      this.rowData = [
        {
          id: 1,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
        {
          id: 2,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
        {
          id: 3,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
        {
          id: 4,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
        {
          id: 5,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
        {
          id: 6,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
      ];
    }
    const unwrap = (value) => {
      if (value && typeof value === "object" && "value" in value) return value.value;
      return value;
    };
    const t = (key) => this.$t(key).toString();
    const currencySymbol = unwrap(this.$store?.state?.currency?.symbol) || "";
    const defs = [
      {
        headerName: t("action"),
        field: "checkbox",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 78,
        cellRenderer: "AgVMenu",
        rowDrag: true,
        cellRendererParams: (params) => ({
          items: [
            {
              label: t("copy"),
              icon: "mdi-content-copy",
              action: (rowData, vm) => vm.addRow(rowData),
            },
            {
              label: t("reverseRow"),
              icon: "mdi-repeat-variant",
              action: (rowData, vm) => vm.reverse(rowData),
            },
            {
              label: t("remove"),
              icon: "mdi-trash-can-outline",
              iconColor: "error",
              action: (rowData, vm) => vm.openDeleteDialog(rowData),
            },
          ],
        }),
        resizable: false,
        pinned: "right",
      },
      {
        headerName: "#",
        colId: "rowNumber",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 50,
        resizable: false,
        pinned: "right",
      },
      {
        headerName: t("given"),
        field: "given",
        editable: true,
        cellEditor: "AgAutoComplete",
        cellEditorPopup: false,
        valueFormatter: (params) => params.value?.name || null,
        cellEditorParams: (params) => ({
          type: "given",
          newBtn: true,
          rules: [(v) => !!v || t("is-required")],
          editorRef: "refProduct" + params.node.rowIndex,
        }),
        cellClassRules: {
          "invalid-cell": (params) => {
            return !!this.invalidCellsMap[params.node.id]?.[params.colDef.field];
          },
        },
        onCellValueChanged: (params) => {
          const rowId = params.node.id;
          const colId = params.colDef.field;

          if (this.invalidCellsMap[rowId]?.[colId] && params.newValue) {
            delete this.invalidCellsMap[rowId][colId];

            if (Object.keys(this.invalidCellsMap[rowId]).length === 0) {
              delete this.invalidCellsMap[rowId];
            }

            // Refresh this specific cell so the class disappears
            this.gridApi.refreshCells({
              rowNodes: [params.node],
              columns: [colId],
              force: true,
            });
          }
        },
        pinned: "right",
      },
      {
        headerName: t("fin4"),
        field: "fin4",
        editable: true,
        cellEditor: "AgAutoComplete",
        cellEditorPopup: false,
        valueFormatter: (params) => params.value?.name || null,
        cellEditorParams: (params) => ({
          type: "detail",
          newBtn: true,
          editorRef: "refFin4" + params.node.rowIndex,
        }),
        pinned: "right",
      },
      {
        headerName: t("fin5"),
        field: "fin5",
        editable: true,
        cellEditor: "AgAutoComplete",
        width: 150,
        cellEditorPopup: false,
        valueFormatter: (params) => params.value?.name || null,
        cellEditorParams: (params) => ({
          type: "detail",
          newBtn: true,
          editorRef: "refFin5" + params.node.rowIndex,
        }),
      },
      {
        headerName: t("fin6"),
        field: "fin6",
        editable: true,
        cellEditor: "AgAutoComplete",
        width: 150,
        cellEditorPopup: false,
        valueFormatter: (params) => params.value?.name || null,
        cellEditorParams: (params) => ({
          type: "detail",
          newBtn: true,
          editorRef: "refFin6" + params.node.rowIndex,
        }),
      },
      {
        headerName: t("debtor"),
        field: "debtor",
        editable: true,
        cellEditor: "AgMoney",
        cellEditorParams: function (params) {
          return {
            currencySymbol: currencySymbol,
            precision: 10,
            numberFormat: params.node.$numberFormat,
          };
        },
        valueFormatter: (params) => {
          const currency = currencySymbol || "";

          if (params.value == null) return `0 ${currency}`;

          const str = params.value.toString();

          // split integer & decimals WITHOUT rounding
          const [intPart, decPart] = str.split(".");

          // format only integer part
          const formattedInt = new Intl.NumberFormat().format(intPart);

          // re-attach decimals + currency
          return decPart
            ? `${formattedInt}.${decPart} ${currency}`
            : `${formattedInt} ${currency}`;
        },
        valueParser: (params) => {
          const number = Number(params.newValue.toString().replace(/,/g, ""));
          return isNaN(number) ? 0 : number;
        },
      },
      {
        headerName: t("creditor"),
        field: "creditor",
        editable: true,
        cellEditor: "AgMoney",
        cellEditorParams: function (params) {
          return {
            currencySymbol: currencySymbol,
            precision: 0,
            numberFormat: params.node.$numberFormat,
          };
        },
        valueFormatter: (params) => {
          const currency = currencySymbol || "";

          if (params.value == null) return `0 ${currency}`;

          const str = params.value.toString();

          // split integer & decimals WITHOUT rounding
          const [intPart, decPart] = str.split(".");

          // format only integer part
          const formattedInt = new Intl.NumberFormat().format(intPart);

          // re-attach decimals + currency
          return decPart
            ? `${formattedInt}.${decPart} ${currency}`
            : `${formattedInt} ${currency}`;
        },
        valueParser: (params) => {
          const number = Number(params.newValue.toString().replace(/,/g, ""));
          return isNaN(number) ? 0 : number;
        },
      },
      {
        headerName: t("description"),
        field: "content",
        editable: true,
        cellEditor: "agLargeTextCellEditor",
        cellEditorPopup: false,
        cellEditorParams: { useFormatter: true, maxLength: 100 },
      },
      {
        headerName: t("count"),
        field: "count",
        editable: true,
        cellEditor: "agNumberCellEditor",
        valueParser: (params) => Number(params.newValue),
        onCellValueChanged: (params) =>
          params.node.setDataValue("count", params.newValue),
      },
      {
        headerName: t("issueTracking"),
        field: "tracking_number",
        editable: true,
        cellEditor: "agNumberCellEditor",
        valueParser: (params) => Number(params.newValue),
        onCellValueChanged: (params) =>
          params.node.setDataValue("issueTracking", params.newValue),
      },
      {
        headerName: t("currency"),
        field: "currency",
        editable: true,
        cellEditor: "AgAutoComplete",
        cellEditorPopup: false,
        valueFormatter: (params) => params.value?.name || null,
        cellEditorParams: { type: "currency" },
      },
      {
        headerName: t("currency-rate"),
        field: "currency_amount",
        editable: true,
        cellEditor: "AgMoney",
        cellEditorParams: function (params) {
          return { currencySymbol: currencySymbol, precision: 0 };
        },
        valueFormatter: (params) => {
          const currency = currencySymbol || "";

          if (params.value == null) return `0 ${currency}`;

          const str = params.value.toString();

          // split integer & decimals WITHOUT rounding
          const [intPart, decPart] = str.split(".");

          // format only integer part
          const formattedInt = new Intl.NumberFormat().format(intPart);

          // re-attach decimals + currency
          return decPart
            ? `${formattedInt}.${decPart} ${currency}`
            : `${formattedInt} ${currency}`;
        },
        valueParser: (params) => {
          const number = Number(params.newValue.toString().replace(/,/g, ""));
          return isNaN(number) ? 0 : number;
        },
      },
    ];
    // freeze and assign to the reactive data property
    this.columnDefs = Object.freeze(defs);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.globalKeyDown);
  },
  methods: {
    getRowId(params) {
      return String(params.data.id);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

      const savedState = localStorage.getItem("AgGridColumnState");
      if (savedState) {
        const columnState = JSON.parse(savedState);
        params.columnApi.applyColumnState({
          state: columnState,
          applyOrder: false,
        });
      }
      this.setInitialFocus();
    },
    globalKeyDown(event) {
      const api = this.gridApi;
      if (!api) return;

      if (api.getEditingCells && api.getEditingCells().length > 0) {
        return;
      }

      const key = event.key;
      if (key === "PageDown" || event.code === "PageDown" || key === "ArrowDown") {
        event.preventDefault();
        this.navigateRow(api, 1);
      }
      if (key === "PageUp" || event.code === "PageUp" || key === "ArrowUp") {
        event.preventDefault();
        this.navigateRow(api, -1);
      }
      if (key === "Enter") {
        const selectedNodes = api.getSelectedNodes();
        if (selectedNodes.length) {
        }
      }
    },
    navigateRow(api, direction) {
      const selectedNodes = api.getSelectedNodes();
      const totalRows = api.getDisplayedRowCount();

      let nextIndex = 0;
      let currentColumn = 0;

      if (selectedNodes.length) {
        const currentIndex = selectedNodes[0].rowIndex;
        const currentColumnIndex = api.getFocusedCell()?.column?.getColId();
        currentColumn = currentColumnIndex;
        nextIndex = currentIndex + direction;
      }

      if (nextIndex < 0) nextIndex = 0;
      if (nextIndex >= totalRows) nextIndex = totalRows - 1;
      api.forEachNode((node) => node.setSelected(false));
      const targetNode = api.getDisplayedRowAtIndex(nextIndex);
      if (targetNode) {
        targetNode.setSelected(true);
        api.ensureIndexVisible(nextIndex);
        api.setFocusedCell(nextIndex, currentColumn);
      }
    },
    setInitialFocus() {
      const api = this.gridApi;
      if (api && api.getDisplayedRowCount() > 0) {
        api.setFocusedCell(0, this.columnDefs[0].field);
        api.getDisplayedRowAtIndex(0).setSelected(true);
      }
    },
    onColumnResized(params) {
      if (params.finished) {
        const columnState = params.columnApi.getColumnState();
        localStorage.setItem("AgGridColumnState", JSON.stringify(columnState));
      }
    },
    onSelectionChanged() {
      const selectedRows = this.gridApi?.getSelectedRows();
      this.selected = selectedRows;

      if (selectedRows.length === 1) {
        this.selectedRowData = selectedRows[0];

        const selectedRowNode = this.gridApi.getRowNode(selectedRows[0].id);
        const selectedRowIndex = selectedRowNode ? selectedRowNode.rowIndex + 1 : null;

        this.selectedRowIndex = selectedRowIndex;
      } else {
        this.selectedRowData = null;
        this.selectedRowIndex = null;
      }
    },
    onRowDragEnd(event) {
      const updated = [];
      this.gridApi.forEachNode((node) => {
        updated.push(node.data);
      });
      this.rowData = updated;
    },
    onRowDragEnd(event) {
      const updated = [];
      this.gridApi.forEachNode((node) => {
        updated.push(node.data);
      });
      this.rowData = updated;
    },

    onProductBtnClick() {
      this.productDialog = true;
    },
    onAccountBtnClick() {
      this.accountDialog = true;
    },
    onDetailBtnClick() {
      this.detailDialog = true;
    },
    onGivenBtnClick() {
      this.givenDialog = true;
    },
    // onModelIconClick(params) {
    //   this.showAGDatePicker = true
    //   this.AGSelectedDate = params.node.data.date
    // },
    // closeAGDatePicker () {
    //   this.showAGDatePicker = false
    // },
    initialMounted() {
      this.typeItems = [
        {
          value: "initial",
          text: this.$t("initial"),
        },
        {
          value: "general",
          text: this.$t("general"),
        },
        {
          value: "draft",
          text: this.$t("draft"),
        },
        {
          value: "closingAccount",
          text: this.$t("closingAccount"),
        },
        {
          value: "closing",
          text: this.$t("closing"),
        },
      ];
      if (this.input) {
        this.model = this.input;
      }
      this.loading = false;
      if (this.itemsProp && this.docCreated == false) {
        this.getNewNum();
      }
      if (this.$route.params.id == null && this.itemsProp == null) {
        this.getDocumentNumber();
        this.clearForm();
      }
    },
    getNewNum() {
      var app = this;
      app.isLoading = true;
      app.loading = true;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            type: app.type,
            date: app.date,
            select: "getDocumentNumber",
          },
        })
        .then((res) => {
          app.newNum = res.data.number;
          if (app.newNum) {
            app.content = app.itemsProp.content;
            app.attachments = app.itemsProp.attachments;
            app.date = app.itemsProp.date;
            app.number = app.newNum;
            app.branch = app.itemsProp.branch;
            app.turningNumber = app.itemsProp.turning_number;
            app.dailyNumber = app.itemsProp.daily_number;
            app.type = app.itemsProp.type;
            app.status = app.itemsProp.last_status
              ? app.itemsProp.last_status.status
              : null;
            const rows = app.itemsProp.article.map((item) => ({
              id: item.id,
              given: item.given || null,
              fin4: item.fin4 || null,
              fin5: item.fin5 || null,
              fin6: item.fin6 || null,
              content: item.content,
              debtor: Number(item.debtor) || 0,
              creditor: Number(item.creditor) || 0,
              count: Number(item.count) || 0,
              tracking_number: Number(item.tracking_number) || 0,
              currency: item.currency || null,
              currency_amount: Number(item.currency_amount) || 0,
            }));

            app.rowData = rows;
            if (app.gridApi) {
              app.gridApi.setRowData(rows);
            }

            if (app.itemsProp.tags) {
              app.tag = app.itemsProp.tags;
              app.more = true;
            }
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    draftStore() {
      this.type = "draft";
      this.alertDialog = false;
      this.draftStatus = true;
      if (this.id) {
        this.update();
      } else {
        this.create();
      }
    },
    getDocumentNumber() {
      this.loading = true;
      var app = this;
      app.isLoading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              type: app.type,
              id: app.id,
              number: app.number,
              date: app.date,
              select: "getDocumentNumber",
            },
          })
          .then((res) => {
            res = res.data;
            if (res.status === "error") {
              app.snakbarText = res.message;
              app.snakbarColor = "pink";
              app.snakbar = true;
              app.number = res.number;
            }
            if (!app.id) {
              app.turningNumber = res.turning_number;
              app.dailyNumber = res.daily_number;
            }
            if (!app.number) {
              app.number = res.number;
            }
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }, 50);
      // setTimeout(() => {
      //   app.$refs.autocomplete.onScroll()
      // }, 1500)
      this.loading = false;
    },
    copyRow() {
      var app = this;
      app.loading = true;
      app.selected.map(function (value, key) {
        app.addRow(value);
      });
      app.loading = false;
      app.selected = [];
      if (app.gridApi) {
        app.gridApi.deselectAll();
      }
    },
    addRow(item) {
      const newId = this.rowData.length
        ? Math.max(...this.rowData.map((r) => r.id)) + 1
        : 1;

      const newRow = {
        id: newId,
        given: item ? item.given : null,
        fin4: item ? item.fin4 : null,
        fin5: item ? item.fin5 : null,
        fin6: item ? item.fin6 : null,
        content: item ? item.content : null,
        debtor: item ? item.debtor : 0,
        creditor: item ? item.creditor : 0,
        count: item ? item.count : 0,
        tracking_number: item ? item.tracking_number : 0,
        currency: item ? item.currency : null,
        currency_amount: item ? item.currency_amount : 0,
      };

      // Add to rowData and update grid
      this.rowData = [...this.rowData, newRow];
      this.gridApi?.setRowData(this.rowData);

      // Refresh to update indexes
      this.gridApi.refreshCells({ force: true });
    },
    reverseRow() {
      var app = this;
      app.loading = true;
      app.selected.map(function (value, key) {
        app.reverse(value);
      });
      app.loading = false;
      app.selected = [];
      if (app.gridApi) {
        app.gridApi.deselectAll();
      }
    },
    reverse(item) {
      const debtor = item.debtor;
      const creditor = item.creditor;

      const updatedItem = {
        ...item,
        debtor: creditor,
        creditor: debtor,
      };

      const rowNode = this.gridApi.getRowNode(String(item.id));
      if (rowNode) {
        rowNode.setData(updatedItem);

        const index = this.rowData.findIndex((r) => r.id === item.id);
        if (index !== -1) {
          this.$set(this.rowData, index, updatedItem);
        }
      } else {
        console.warn("Row not found for id", item.id);
      }
    },
    remove() {
      if (!this.deleteItem) return;

      // Remove from both grid and local rowData
      this.rowData = this.rowData.filter((r) => r.id !== this.deleteItem.id);

      // Apply transaction to grid
      this.gridApi?.setRowData(this.rowData);

      // Refresh to update indexes
      this.gridApi.refreshCells({ force: true });

      this.deleteItem = null;
      this.deletDialog = false;
    },
    removegroup() {
      if (!this.selected?.length) return;

      // Remove all selected rows from rowData
      const selectedIds = this.selected.map((r) => r.id);
      this.rowData = this.rowData.filter((r) => !selectedIds.includes(r.id));

      // Update grid with new data
      this.gridApi?.setRowData(this.rowData);

      // Refresh grid to update row indexes (# column)
      this.gridApi.refreshCells({ force: true });

      // Reset selection & close dialog
      this.deletDialog = false;
      this.selected = [];
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openDeleteDialogVerify() {
      if (this.selected?.length > 0) {
        this.deletDialog = true;
      }
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: "ProductEdit", params: { id: item.id } });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "products", {
          params: {
            search: app.search,
            page: app.tableOptions.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
        .then((res) => {
          res = res.data;
          app.items = res.data;
          app.totalItems = res.total;
          app.from = res.from;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    checkProduct(item, key) {
      if (item) {
        var index = this.items.findIndex((x) => x.product.id === item.id);
        if (index !== key) {
          this.$refs["refProduct" + key].clear();
          this.snakbarText = this.$t("alert-product-is-repetitive");
          this.snakbarColor = "pink";
          this.snakbar = true;
        }
      }
    },
    checkCount(item) {
      if (
        this.$store.state.negative_inventory === "no" &&
        this.type === "remittance" &&
        parseFloat(item.count) > parseFloat(item.product.stock.count)
      ) {
        this.snakbarText = this.$t("alert-inventory-is-not-enough");
        this.snakbarColor = "pink";
        this.snakbar = true;
        item.count = 0;
      }
    },
    resetRowData() {
      this.rowData = [
        {
          id: 1,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
        {
          id: 2,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
        {
          id: 3,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
        {
          id: 4,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
        {
          id: 5,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
        {
          id: 6,
          given: null,
          fin4: null,
          fin5: null,
          fin6: null,
          content: null,
          debtor: 0,
          creditor: 0,
          count: 0,
          tracking_number: 0,
          currency: null,
          currency_amount: 0,
        },
      ];
    },
    create() {
      if (!this.$refs.form.validate()) return false;

      if (
        this.rowData.some(
          (item) =>
            item.given == null &&
            item.fin4 == null &&
            item.fin5 == null &&
            item.fin6 == null &&
            item.content == null &&
            item.debtor == 0 &&
            item.creditor == 0 &&
            item.count == 0 &&
            item.tracking_number == 0 &&
            item.currency == null &&
            item.currency_amount == 0
        )
      ) {
        const emptyRowIndexes = this.rowData
          .map((item, index) => ({ item, index }))
          .filter(
            ({ item }) =>
              item.given == null &&
              item.fin4 == null &&
              item.fin5 == null &&
              item.fin6 == null &&
              item.content == null &&
              item.debtor == 0 &&
              item.creditor == 0 &&
              item.count == 0 &&
              item.tracking_number == 0 &&
              item.currency == null &&
              item.currency_amount == 0
          )
          .map(({ index }) => index);

        emptyRowIndexes
          .sort((a, b) => b - a)
          .forEach((index) => {
            this.rowData.splice(index, 1);
          });
      } else {
        if (
          !this.checkAgTableValidation(
            this.columnDefs,
            this.rowData,
            this.gridApi,
            this.invalidCellsMap
          )
        )
          return false;
      }

      if (
        this.totals &&
        this.totals.debtor !== this.totals.creditor &&
        !this.draftStatus
      ) {
        this.alertText = this.$t("storeDraftDocument");
        this.alertDialog = true;
        return false;
      }

      var app = this;
      app.isLoading = true;
      app.$axios
        .post(this.$endpoint + "accounting", {
          content: app.content,
          type: app.type,
          date: app.date,
          number: app.number,
          turning_number: app.turningNumber,
          daily_number: app.dailyNumber,
          status: app.status,
          branch: app.branch,
          tag: app.tag,
          items: app.rowData,
          attachments: app.attachments,
        })
        .then((res) => {
          res = res.data;
          app.$emit("close", app.$route);
          if (app.$refs.refFilePicker !== undefined && app.attachments) {
            app.$refs.refFilePicker.create(res.data.id);
          }

          app.snakbarText = app.$t("documentRegisterd");
          app.snakbarColor = "green";
          app.snakbar = true;

          app.clearForm();
          app.docCreated = true;
          app.initialMounted();
          app.getDocumentNumber();
          app.$refs.form.resetValidation();
          app.resetRowData();
        })
        .catch((err) => {
          if (err.response && err.response.status === 409) {
            this.$store.commit("SET_PLAN_DIALOG", true);
          }
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    update() {
      if (!this.$refs.form.validate()) return false;

      if (
        this.rowData.some(
          (item) =>
            item.given == null &&
            item.fin4 == null &&
            item.fin5 == null &&
            item.fin6 == null &&
            item.content == null &&
            item.debtor == 0 &&
            item.creditor == 0 &&
            item.count == 0 &&
            item.tracking_number == 0 &&
            item.currency == null &&
            item.currency_amount == 0
        )
      ) {
        const emptyRowIndexes = this.rowData
          .map((item, index) => ({ item, index }))
          .filter(
            ({ item }) =>
              item.given == null &&
              item.fin4 == null &&
              item.fin5 == null &&
              item.fin6 == null &&
              item.content == null &&
              item.debtor == 0 &&
              item.creditor == 0 &&
              item.count == 0 &&
              item.tracking_number == 0 &&
              item.currency == null &&
              item.currency_amount == 0
          )
          .map(({ index }) => index);

        emptyRowIndexes
          .sort((a, b) => b - a)
          .forEach((index) => {
            this.rowData.splice(index, 1);
          });
      } else {
        if (
          !this.checkAgTableValidation(
            this.columnDefs,
            this.rowData,
            this.gridApi,
            this.invalidCellsMap
          )
        )
          return false;
      }

      if (
        this.totals &&
        this.totals.debtor !== this.totals.creditor &&
        !this.draftStatus
      ) {
        this.alertText = this.$t("storeDraftDocument");
        this.alertDialog = true;
        return false;
      }
      var app = this;
      app.isLoading = true;
      app.$axios
        .put(
          this.$endpoint + "accounting/" + (app.documentRouteId || app.$route.params.id),
          {
            content: app.content,
            type: app.type,
            date: app.date,
            number: app.number,
            turning_number: app.turningNumber,
            daily_number: app.dailyNumber,
            status: app.status,
            branch: app.branch,
            tag: app.tag,
            items: app.rowData,
            attachments: app.attachments,
          }
        )
        .then((res) => {
          res = res.data;
          if (app.$refs.refFilePicker !== undefined) {
            app.$refs.refFilePicker.create(res.data.id);
          }
          app.loadedDocumentId = null;

          app.clearForm();
          app.$emit("close", app.$route);
          app.goTo("accountingList");
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    syncRouteDocument() {
      const id = this.documentRouteId;
      if (id != null && String(this.$route.params.id) !== String(id)) {
        return;
      }
      if (id == null) {
        this.loadedDocumentId = null;
        return;
      }
      if (String(this.loadedDocumentId) === String(id)) {
        return;
      }
      if (this.isLoading && String(this.id) === String(id)) {
        return;
      }
      this.id = id;
      this.show();
    },
    show() {
      var app = this;
      const docId = app.documentRouteId || app.$route.params.id;
      if (docId == null) {
        return;
      }
      app.isLoading = true;
      app.loading = true;

      app.$axios
        .get(this.$endpoint + "accounting/" + docId + "/edit", {
          params: {
            id: docId,
          },
        })
        .then((res) => {
          res = res.data;
          // app.id = res.id
          app.content = res.content;
          app.attachments = res.attachments;
          app.date = res.date;
          app.number = res.number;
          app.branch = res.branch;
          app.turningNumber = res.turning_number;
          app.dailyNumber = res.daily_number;
          app.type = res.type;
          app.status = res.last_status ? res.last_status.status : null;
          const rows = res.article.map((item) => ({
            id: item.id,
            given: item.given || null,
            fin4: item.fin4 || null,
            fin5: item.fin5 || null,
            fin6: item.fin6 || null,
            content: item.content,
            debtor: Number(item.debtor) || 0,
            creditor: Number(item.creditor) || 0,
            count: Number(item.count) || 0,
            tracking_number: Number(item.tracking_number) || 0,
            currency: item.currency || null,
            currency_amount: Number(item.currency_amount) || 0,
          }));

          app.rowData = rows;
          if (app.gridApi) {
            app.gridApi.setRowData(rows);
          }

          if (res.tags) {
            app.tag = res.tags;
            app.more = true;
          }

          app.loadedDocumentId = docId;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.isLoading = false;
          app.loading = false;
        });
    },
    clearForm() {
      this.selected = [];

      if (this.gridApi) {
        // clear AG Grid selections
        this.gridApi.deselectAll();
        // Update grid with new data
        this.gridApi?.setRowData([]);
        // Refresh grid to update row indexes (# column)
        this.gridApi.refreshCells({ force: true });

        this.rowData = [
          {
            id: 1,
            given: null,
            fin4: null,
            fin5: null,
            fin6: null,
            content: null,
            debtor: 0,
            creditor: 0,
            count: 0,
            tracking_number: 0,
            currency: null,
            currency_amount: 0,
          },
          {
            id: 2,
            given: null,
            fin4: null,
            fin5: null,
            fin6: null,
            content: null,
            debtor: 0,
            creditor: 0,
            count: 0,
            tracking_number: 0,
            currency: null,
            currency_amount: 0,
          },
          {
            id: 3,
            given: null,
            fin4: null,
            fin5: null,
            fin6: null,
            content: null,
            debtor: 0,
            creditor: 0,
            count: 0,
            tracking_number: 0,
            currency: null,
            currency_amount: 0,
          },
          {
            id: 4,
            given: null,
            fin4: null,
            fin5: null,
            fin6: null,
            content: null,
            debtor: 0,
            creditor: 0,
            count: 0,
            tracking_number: 0,
            currency: null,
            currency_amount: 0,
          },
          {
            id: 5,
            given: null,
            fin4: null,
            fin5: null,
            fin6: null,
            content: null,
            debtor: 0,
            creditor: 0,
            count: 0,
            tracking_number: 0,
            currency: null,
            currency_amount: 0,
          },
          {
            id: 6,
            given: null,
            fin4: null,
            fin5: null,
            fin6: null,
            content: null,
            debtor: 0,
            creditor: 0,
            count: 0,
            tracking_number: 0,
            currency: null,
            currency_amount: 0,
          },
        ];
      }

      this.attachments = null;
      this.printDialog = false;
      this.deletDialog = false;
      this.alertDialog = false;
      this.alertText = null;
      this.draftStatus = false;
      this.showSelect = false;
      this.filter = false;
      this.render = true;
      this.valid = true;
      this.number = null;
      this.content = null;
      this.model = null;
      this.from = 1;
      this.taskDialog = null;
      this.id = null;
      this.status = null;
      this.tag = null;
      this.temp = null;
      this.deleteItem = null;
      this.sellStatus = null;
      this.turningNumber = null;
      this.dailyNumber = null;
      this.items = [];
      this.dialog = null;
      this.date = this.getToday();
      this.timer = 0;
      this.totalItems = 1000;
      this.isLoading = false;
      this.snakbar = false;
      this.type = "general";
      this.taskId = null;
      this.snakbarText = null;
    },
    saveOrder(event) {
      const movedItem = this.items.splice(event.oldIndex, 1)[0];
      this.items.splice(event.newIndex, 0, movedItem);
    },
  },
};
</script>
<style>
table.visual {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
table.visual td {
  padding: 10px;
  border: 1px solid #ddd;
}
table.visual .column-width {
  width: 150px;
}
table.visual .column-width-small {
  width: 120px;
}
@media (max-width: 768px) {
  table.visual td {
    width: 100%;
    display: block;
    box-sizing: border-box;
  }
  table.visual {
    width: 100%;
    table-layout: auto;
  }
}
@media (max-width: 480px) {
  table.visual .column-width {
    width: 100%;
  }
  table.visual .column-width-small {
    width: 100%;
  }
}
.v-toolbar {
  flex: none !important;
}
.v-tabs-bar {
  height: 30px;
}
/* .v-tabs-bar .v-slide-group__wrapper .v-slide-group__content.v-tabs-bar__content .v-tab {
  height: 28px !important;
} */
.ag-theme-alpine.accounting .ag-body-horizontal-scroll {
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
}
.ag-theme-alpine.accounting .ag-body-horizontal-scroll ::-webkit-scrollbar {
  height: 8px;
}
.ag-theme-alpine.accounting .ag-body-horizontal-scroll ::-webkit-scrollbar-track {
  background: #f1f0f0;
  border-radius: 6px;
}
.ag-theme-alpine.accounting .ag-body-horizontal-scroll ::-webkit-scrollbar-thumb {
  background: #bdbdbdd2;
  border-radius: 6px;
}
.ag-theme-alpine.accounting .ag-body-horizontal-scroll ::-webkit-scrollbar-thumb:hover {
  background: #9e9e9ecf;
}
.v-data-table__wrapper {
  min-height: 0;
  height: 100%;
}
.invalid-cell {
  background-color: rgba(255, 102, 102, 0.4) !important; /* light red */
  transition: background-color 0.3s ease; /* smooth transition */
}

.ag-input-field-input.ag-checkbox-input {
  cursor: pointer;
}
.ag-theme-alpine.accounting .ag-header-cell,
.ag-theme-alpine.accounting .ag-header-group-cell {
  padding: 10px;
}
.ag-theme-alpine.accounting.ag-rtl .ag-cell-wrapper {
  flex-direction: row-reverse;
}
.ag-wrapper.ag-input-wrapper.ag-checkbox-input-wrapper.ag-checked {
  background-color: transparent;
}
.ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell.ag-focus-managed:nth-child(1),
.ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell.ag-focus-managed:nth-child(3) {
  overflow: visible;
}
.ag-theme-alpine.accounting
  .ag-pinned-right-cols-container
  .ag-row
  .ag-cell:nth-child(2) {
  text-align: center;
}
.ag-theme-alpine.accounting .ag-header-cell-resize::after {
  display: none;
}
.ag-theme-alpine.accounting
  .ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell:nth-child(1) {
  border-right: none;
  justify-content: center;
}
.ag-theme-alpine.accounting .ag-row {
  border-bottom: 1px solid #d3d3d3;
}
.ag-theme-alpine.accounting .ag-cell {
  border-right: 1px solid #d3d3d3;
}
.ag-theme-alpine.accounting .ag-header-cell {
  border-right: 1px solid #b0b0b0;
}
.ag-theme-alpine.accounting .ag-cell.ag-column-first {
  border-right: none;
  padding: 0;
}
.ag-theme-alpine.accounting .ag-rtl .ag-header-select-all,
.ag-theme-alpine.accounting .ag-rtl .ag-selection-checkbox {
  margin-left: 0;
}
.ag-theme-alpine.accounting .ag-rtl .ag-row-drag {
  margin-left: 2px;
}
.ag-cell-wrapper {
  position: relative;
  top: -2px;
  padding-right: 6px;
}
.v-data-table.summary-footer tbody tr:nth-child(1):hover,
.v-data-table.summary-footer tbody tr:nth-child(2):hover,
.v-data-table.summary-footer tbody tr:nth-child(3):hover {
  background-color: initial !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:nth-child(odd) {
  background-color: transparent;
}
.border-datatable
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:not(.v-data-table__mobile-row):first-child {
  border-right: none !important;
}
.ag-header-cell.ag-column-first .ag-header-cell-comp-wrapper {
  width: 0;
}
.ag-header-cell.ag-column-first {
  justify-content: end;
  padding-left: 15px;
}
.ag-theme-alpine.accounting
  .ag-pinned-right-header
  .ag-header-row.ag-header-row-column
  .ag-header-cell:nth-child(2)
  .ag-header-cell-label {
  justify-content: center;
}
.ag-theme-alpine.accounting .ag-checkbox-input-wrapper {
  width: 15px;
  height: 15px;
}
.ag-theme-alpine.accounting .ag-checkbox-input-wrapper:focus-within {
  box-shadow: none;
}
.ag-theme-alpine.accounting .ag-icon-grip::before {
  font-family: "Material Design Icons";
  font-size: 15px;
  color: silver;
  content: "\F01BE";
  position: relative;
  top: -3px;
}
.ag-theme-alpine.accounting .ag-row-selected,
.ag-row-selected::before {
  background-color: rgb(169 217 255 / 12%);
}
.ag-theme-alpine .ag-row-hover,
.ag-theme-alpine .ag-row-hover::after,
.ag-theme-alpine .ag-row-hover::before {
  background-color: rgb(169 217 255 / 12%) !important;
}
.ag-row-hover.ag-row-selected::before {
  background-image: none !important;
}
.ag-theme-alpine.accounting .ag-cell-value.ag-cell.ag-cell-data-changed {
  background-color: rgb(255 102 102 / 41%) !important;
}
.ag-theme-alpine.accounting
  .ag-pinned-right-cols-container
  .ag-cell.ag-column-first
  .ag-cell-wrapper
  .ag-drag-handle.ag-row-drag,
.ag-theme-alpine.accounting
  .ag-pinned-right-cols-container
  .ag-cell.ag-column-first
  .ag-cell-wrapper
  .ag-selection-checkbox {
  margin-left: 10px;
}
.ag-theme-alpine.accounting
  .ag-pinned-right-cols-container
  .ag-cell.ag-column-first
  .ag-cell-wrapper
  .ag-cell-value {
  flex: none;
}
</style>
